import React from "react";
import "./styles/unlocking.css";
import giftBox from "../../assets/images/airdrop/giftbox.png";
export default function Unlocking() {
  return (
    <div className="unlocking-container container-fluid pb-5 ">
      <div className="row py-2 d-flex justify-content-center align-items-center ">
        <div className="col-12 d-flex justify-content-center align-items-center">
          <img src={giftBox} alt="" className="me-3" />
        </div>
        <div className="col-12 d-flex justify-content-center align-items-center">
          <span className="airdrop-para">Unlocking Rules</span>
        </div>
        <div className="col-12 d-flex justify-content-center align-items-center">
          <span className="receive-para">
            Complete a transaction to unlock ET
          </span>
        </div>
      </div>
      <div className="row py-2 d-flex justify-content-center align-items-center ">
        <div className="col-md-4 col-sm-9 my-2 ">
          <div className="right-bar d-flex justify-content-center align-items-center flex-column pb-4">
            <span className="airdrop-amount">$57,500</span>
            <span className="airdrop-amount-title ">My Reward</span>
          </div>
        </div>
        <div className="col-md-4 col-sm-9 my-2 ">
          <div className="right-bar d-flex justify-content-center align-items-center flex-column pb-4">
            <span className="airdrop-amount">$57,500</span>
            <span className="airdrop-amount-title ">My Reward</span>
          </div>
        </div>
        <div className="col-md-4 col-sm-9 my-2 ">
          <div className="right-bar d-flex justify-content-center align-items-center flex-column pb-4">
            <span className="airdrop-amount">$57,500</span>
            <span className="airdrop-amount-title ">My Reward</span>
          </div>
        </div>
      </div>
    </div>
  );
}
